import { useApp } from '@libs/core';
import { TViewCommonOption } from '@libs/types';
import React from 'react';
import { ButtonRowView } from '../../Buttons/ButtonRowView';
import { ActionNameEnum, TServerCalculationFunc } from '../utils/types';
import { CodeTimerScreen } from './CodeTimerScreen';

type TCodeAppliedButton = {
    labelNewCode?: string;
    labelRemoveCode?: string;
    labelUsePromoCode?: string;
    textRemovedCode?: string;
    enterCodePopup: React.ReactNode;
    value: string;
    isFrom: boolean;
    handlingAutoApplied?: boolean;
    onServerCalculation: TServerCalculationFunc;
    parentStyleNames?: TViewCommonOption['parentStyleNames'];
};
const CodeAppliedButtons = ({
    labelNewCode,
    labelRemoveCode,
    labelUsePromoCode,
    handlingAutoApplied,
    enterCodePopup,
    value,
    isFrom,
    onServerCalculation,
    textRemovedCode,
    parentStyleNames,
}: TCodeAppliedButton) => {
    const { setPopup, setModal } = useApp();
    const handleRemoveCodeClick = async () => {
        if (value) {
            const result = await onServerCalculation(value, 'code', isFrom, ActionNameEnum.onRemoveCode);
            if (result) {
                setPopup(null);
                setModal(<CodeTimerScreen text={textRemovedCode} />);
            } else {
                setPopup(null);
            }
        }
    };
    return (
        <>
            <ButtonRowView
                label={handlingAutoApplied ? labelUsePromoCode : labelNewCode}
                iconName={'ic_arrow_retry'}
                parentStyleNames={parentStyleNames}
                onClick={() => setPopup(enterCodePopup)}
            />
            {!handlingAutoApplied && (
                <ButtonRowView as="button" label={labelRemoveCode} iconName={'ic_x'} parentStyleNames={parentStyleNames} onClick={handleRemoveCodeClick} />
            )}
        </>
    );
};
export { CodeAppliedButtons };
